// Links "研究 08" / "Study 08" / "studies 10, 14" in page text to the research
// summaries in the project (screen_inspector/docs/research/NN_*.md on GitLab).
import React from 'react';
import { REPO_URL } from './ui';
import styles from './ScreenInspector.module.css';

const FILES = {
    '01': '01_offline',
    '02': '02_choice',
    '03': '03_true_false',
    '04': '04_region',
    '05': '05_region_all_pages',
    '06': '06_locate',
    '07': '07_target_open_close',
    '08': '08_state_true_false',
    '09': '09_status_choice',
    '10': '10_read_pressure',
    '12': '12_page_tree',
    '13': '13_page_tree_all',
    '14': '14_image_choice',
    '15': '15_pixels_first',
};

const RESEARCH = `${REPO_URL}/-/blob/main/screen_inspector/docs/research`;
export const RESEARCH_INDEX = `${RESEARCH}/README.md`;

export function studyUrl(nn) {
    return FILES[nn] ? `${RESEARCH}/${FILES[nn]}.md` : null;
}

// "研究 10、14", "Study 08", "studies 14, 15", "Studies 10 and 14"
const REF = /(研究|[Ss]tud(?:y|ies))(\s*)(\d{2}(?:\s*(?:、|，|,|and|和)\s*\d{2})*)/g;

/** Renders text with every study number turned into a link. */
export function StudyText({ text }) {
    if (!text) return null;
    const out = [];
    let last = 0;
    let m;
    REF.lastIndex = 0;
    while ((m = REF.exec(text)) !== null) {
        if (m.index > last) out.push(text.slice(last, m.index));
        out.push(m[1] + m[2]);
        const parts = m[3].split(/(\d{2})/);
        for (let i = 0; i < parts.length; i += 1) {
            const part = parts[i];
            const url = /^\d{2}$/.test(part) && studyUrl(part);
            out.push(url
                ? <a key={`${m.index}-${i}`} className={styles.studyLink} href={url} target="_blank" rel="noreferrer">{part}</a>
                : part);
        }
        last = m.index + m[0].length;
    }
    if (last < text.length) out.push(text.slice(last));
    return <>{out}</>;
}
